import { get, includes, some } from 'lodash';
import { validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import { validationsApi } from 'services/api';

export const accessibleUrlValidation = {
    validationFn: async (value, _, { formAccountId, bypassUrlResponseValidation, accessibleUrlCache }) => {
        if (bypassUrlResponseValidation || value === accessibleUrlCache.current) {
            return true;
        }
        return validateWebsiteUrlTracking(formAccountId, value);
    },
    messageId: 'validations.error.field.url.pixel',
    defaultMessage: `We couldn't find a Pixel base code on this website that matches your account. Please follow the previous steps to install the code`,
};

export const exactAccountIdMatchValidation = {
    validationFn: async (value, _, { formAccountId, bypassUrlResponseValidation, accessibleUrlCache }) => {
        if (bypassUrlResponseValidation || value === accessibleUrlCache.current) {
            return true;
        }
        return validateWebsiteUrlTrackingExactAccountIdMatch(formAccountId, value);
    },
    messageId: 'validations.error.field.url.pixel',
    defaultMessage: `We couldn't find a Pixel base code on this website that matches your account. Please follow the previous steps to install the code`,
};

export const emptyValidation = {
    validationFn: validationFunctions.isNotEmpty,
    messageId: 'validations.error.field.url.empty',
};

const protocolRegex = /^(https?:\/\/)/;
export const protocolValidation = {
    validationFn: (value, _) => protocolRegex.test(value),
    messageId: 'validations.error.field.url.protocol',
};

export async function validateWebsiteUrlTracking(accountId, websiteUrl) {
    if (!websiteUrl) {
        return false;
    }

    try {
        const response = await validationsApi.validateWebsiteUrlTracking(accountId, websiteUrl);
        return (
            get(response, 'results.length', 0) > 0 &&
            some(response.results, result => includes(result.trackingMethods, 'TFA'))
        );
    } catch (e) {
        return false;
    }
}
export async function validateWebsiteUrlTrackingExactAccountIdMatch(accountId, websiteUrl) {
    if (!websiteUrl) {
        return false;
    }

    try {
        const response = await validationsApi.validateWebsiteUrlTracking(accountId, websiteUrl);
        return (
            get(response, 'results.length', 0) > 0 &&
            some(response.results, result => includes(result.trackingMethods, 'TFA_ACCOUNT_ID_EXACT_MATCH'))
        );
    } catch (e) {
        return false;
    }
}
